import { StyleObject } from 'styletron-react'
import { merchantTheme } from 'theme'

export type BadgeTone =
  | 'neutral'
  | 'positive'
  | 'warning'
  | 'negative'
  | 'muted'

export type BadgeAppearance = {
  labelKey: string
  tone: BadgeTone
}

export const UNAVAILABLE_APPEARANCE: BadgeAppearance = {
  labelKey: 'badge.unavailable',
  tone: 'neutral',
}

export function badgeStyle(tone: BadgeTone): StyleObject {
  const { colors } = merchantTheme
  switch (tone) {
    case 'positive':
      return {
        color: colors.belizeHole50,
        backgroundColor: colors.belizeHole10,
      }
    case 'warning':
      return { color: colors.eggYolk50, backgroundColor: colors.eggYolk10 }
    case 'negative':
      return { color: colors.cayenne50, backgroundColor: colors.cayenne10 }
    case 'muted':
      return {
        color: colors.grey70,
        backgroundColor: colors.white,
        border: `1px solid ${colors.grey20}`,
      }
    case 'neutral':
      return { color: colors.grey70, backgroundColor: colors.grey20 }
  }
}
